import { Answer, AnswersMap, Question } from "../types";

/**
 * Respuestas para el resumen del cuestionario native. En native no se guarda
 * respuesta a respuesta: viven en el hook como mapa campo → valor, y el resumen
 * pide la lista `{question_id, value, label}` que en el monolito llega con el
 * árbol (vacía en native, por eso el resumen salía sin preguntas). Solo las
 * preguntas que se ven y tienen respuesta; misma clave de campo que el hook.
 */
export const summaryAnswersFromMap = (questions: Question[], answers: AnswersMap): Answer[] =>
  questions.flatMap((question) => {
    const field = question.field.split("::").pop() || question.name;
    const value = answers[field] ?? answers[question.name];
    if (undefined === value || null === value || "" === value) {
      return [];
    }

    return [{ question_id: question.id, value, label: null }];
  });
